import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4241f45f&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./scss.scss?vue&type=style&index=0&id=4241f45f&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4241f45f",
  null
  
)

export default component.exports